import React from "react";
import styled from "styled-components";
import { BankIconLarge, Stack, Text, util } from "@thecb/components";
import { fallbackValues } from "./FormattedBankAccount.theme";

const { themeComponent } = util.theme;

export const BankItemWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
export const BankIconWrapper = styled.div`
  margin-right: 8px;
  width: 36px;
  height: auto;
  display: flex;
`;

export const BankAccountText = styled.p`
  color: ${({ color }) => color};
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
  text-align: left;
  margin-right: 0.5rem;
  display: inline-block;
`;

const CHECKING = "CHECKING";
const SAVINGS = "SAVINGS";

const FormattedBankAccount = ({
  lastFour,
  accountType,
  autoPay,
  themeValues
}) => (
  <BankItemWrapper>
    <BankIconWrapper>
      <BankIconLarge />
    </BankIconWrapper>
    <Stack childGap="0">
      {accountType === CHECKING && (
        <BankAccountText color={themeValues.textColor}>
          Checking Account ending in {lastFour}
        </BankAccountText>
      )}
      {accountType === SAVINGS && (
        <BankAccountText color={themeValues.textColor}>
          Savings Account ending in {lastFour}
        </BankAccountText>
      )}
      {autoPay && (
        <Text
          variant="p"
          color={themeValues.autopayTextColor}
          extraStyles={`font-style: italic; font-size: .75rem;`}
        >{`Autopay On`}</Text>
      )}
    </Stack>
  </BankItemWrapper>
);

export default themeComponent(
  FormattedBankAccount,
  "FormattedBankAccount",
  fallbackValues
);
